export default function getDeliveryId(state) {
	return !!state.checkout.shipping.delivery_id ? state.checkout.shipping.delivery_id : null;
}



// WEBPACK FOOTER //
// ./src/store/utils/getDeliveryId.js